import { onDOMContentLoaded } from "tsi-common-react/src/utils/events";
import { getHash } from "tsi-common-react/src/utils/urls";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

// The PLC configurator now renders inside the reactivated document tree (via
// ProductLineCollectionPageTemplate -> PLCConfiguratorApp), fed by the
// document's plc_configurator + cms_json props; the CMS payload it needs is
// decoded there, so this residual module no longer parses
// #product-detail-container[data-cms]. It keeps only the review-anchor
// side-effect below.
const document = getDocument();

// Add attribute to fix inconsitent anchoring to PDP reviews
const reviewsElem = "reviews__body";
const hash = getHash(reviewsElem);
if (hash && document) {
    onDOMContentLoaded.on(async () => {
        document.body.setAttribute("scrollToReviews", hash.toString());
    });
}
